import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CancelarPropostaModel } from 'src/app/aplicacao/models/cancelar-proposta.model';
import { LIMITES_CARACTERES } from 'src/app/aplicacao/helper/limites-caracteres.const';
import { MensagemMotivo } from 'src/app/aplicacao/models/mensagens-motivo.model';
import { MotivosPropostaService } from 'src/app/services/motivos-proposta.service';
import { OffcanvasService } from 'src/app/shared/services/offcanvas.service';

@Component({
  selector: 'app-formulario-cancelar-proposta',
  templateUrl: './formulario-cancelar-proposta.component.html',
  styleUrls: ['./formulario-cancelar-proposta.component.scss']
})
export class FormularioCancelarPropostaComponent {
  @Input() propostaId;
  @Output() onSubmitSuccess: EventEmitter<any> = new EventEmitter();
  @Output() onClickFechar: EventEmitter<any> = new EventEmitter();
  model = new CancelarPropostaModel();
  validarFormulario = true;
  listaMotivos: MensagemMotivo[];
  motivoSelecionado: string;
  subscrition = new Subscription();
  
  constructor(
    private motivosProposta: MotivosPropostaService,
    private offcanvasService: OffcanvasService
    ) { }

  ngOnInit() {
    this.listarMotivosCancelamento();
    this.subscrition = this.offcanvasService.aoFecharOffcanvas.subscribe({
      next: () => this.limparFormulario()
    });
  }

  ngOnDestroy() {
    this.subscrition.unsubscribe();
  }

  limparFormulario() {
    this.model = new CancelarPropostaModel()
  }

  listarMotivosCancelamento(){
    this.motivosProposta.motivosCancelarProposta().subscribe({
      next: data => {
        this.listaMotivos = data.sort((a,b) => a < b ? 1:-1)
      }
    });
  }

  radioChange(ev) {
    if(ev.value === 1) {
      this.model.asForm.controls["observacao"].setValidators([Validators.required, Validators.maxLength(LIMITES_CARACTERES.OBSERVACAO)]);
    } else {
      this.model.asForm.controls["observacao"].clearValidators();
      this.model.asForm.controls["observacao"].setValidators([Validators.maxLength(LIMITES_CARACTERES.OBSERVACAO)]);
      this.model.asForm.controls["observacao"].setValue("");
    }
    this.model.asForm.controls["observacao"].updateValueAndValidity();
  }
  
  enviar(): void {
    this.model.asForm.controls.propostaId.setValue(this.propostaId);
    if(this.model.form.valid) {
      this.validarFormulario = true;
      this.onSubmitSuccess.emit(this.model.form.value);
      this.limparFormulario();
    } else {
      this.validarFormulario = false;
    }
  }

  fechar(){
    this.onClickFechar.emit(true);
    this.limparFormulario();
  }

  protected readonly LIMITES_CARACTERES = LIMITES_CARACTERES;
}
